import {initItemcardImages} from "../../../arivaGlobal/src/js/itemcardImages";
import {initRatingStars} from "../../../default/global/js/rating";
import {triggerCopyLink} from "../../../default/global/js/copyToClipboard";
import {itemcardSubscriptions} from "../../../default/global/js/subscriptions";
import {shareItemcardModal} from "../../../default/global/js/shareItemcard";
import {initVariantSelectionSlider} from "../../../default/global/js/variantSelectionSlider";
import {initCustomization} from "../../../arivaGlobal/src/ts/customization";
import {init360Images} from "../../../arivaGlobal/src/js/init360Images";
import {openFullscreenGallery} from "../../../arivaGlobal/src/js/fullscreengallery";
import {filterTable} from "../../../arivaGlobal/src/js/filterSpareparts";
import {Tooltip} from "../../../default/global/js/tooltip";
import {checkAndHideAmountLines} from "../../../arivaGlobal/src/js/hidePrices";
import {handleOnboardingModal} from "../../../arivaGlobal/src/js/onboadingModal";
import {initDescriptionCollapse} from "../../../arivaGlobal/src/js/itemcardDescriptionCollapse";
import {initVehiclesSwiper} from "../../../arivaGlobal/src/js/itemcardVehiclesSwiper";

window.addEventListener("load", (event) => {
    checkAndHideAmountLines();
    initItemcardImages();
    initRatingStars();
    triggerCopyLink();
    itemcardSubscriptions();
    shareItemcardModal();
    initVariantSelectionSlider();
    initCustomization();
    init360Images();
    initDescriptionCollapse();
    initVehiclesSwiper();
    //handleOnboardingModal();

    const positionInput = document.querySelector('.js-position-input');
    if (positionInput) {
        positionInput.addEventListener('keyup', () => {
            console.log('test');
            filterTable(positionInput, '.js-position');
        });
    }

    const articleNumber = document.querySelector('.js-article-number-input');
    if(articleNumber) {
        articleNumber.addEventListener('keyup', () => {
            filterTable(articleNumber, '.js-article-number');
        });
    }

    const description = document.querySelector('.js-description-input');
    if(description) {
        description.addEventListener('keyup', () => {
            filterTable(description, '.js-description');
        });
    }

    for (let item of document.querySelectorAll(".js-itemcardOpenGallery")) {
        item.addEventListener('click', function (event) {
            openFullscreenGallery(item,".js-itemcardOpenGalleryItem");
        });
    }

    
});
